import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { notification, Flex } from 'ui';
import TextArea from 'antd/lib/input/TextArea';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { UploadButton } from './upload-xml-button';


const ErrorTitle = styled.p`
  font-weight: bold;
  font-size: 15px;
`;

const StyledInfoReference = styled.p`
  margin-top: 10px;
  font-size: 12px;
`;

const SerialNumbers = styled.div`
  margin-top: 20px;
`;

const StyledTextArea = styled(TextArea)`
  resize: none;
`;

const Buttons = styled(Flex)`
  > :first-child {
    margin-right: 5px;
  }
  justify-content: flex-end;
  margin-top: 15px;
`;

const Footer = styled.p`
  margin-top: 10px;
`;

const NotFoundError = ({
  title,
  numberNotFound,
  totalNumber,
  reference,
  intl,
  createXMLRequest,
  action,
  customerCenter,
  notFoundSerialNumbers,
  notFoundFunctionalLocationNumbers,
  numberFound,
  hasNext = false,
  goToNextProblem,
}) => {
  const notFoundNumbers = notFoundSerialNumbers?.length ?
    notFoundSerialNumbers : notFoundFunctionalLocationNumbers;
  const type = notFoundSerialNumbers?.length ?
    intl.formatMessage({ id: 'common.objects.equipment' }).toLowerCase() :
    intl.formatMessage({ id: 'common.objects.functionallocation' }).toLowerCase();

  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      {title && <ErrorTitle>{title}</ErrorTitle>}
      <div>
        {intl.formatMessage(
          { id: 'fileUpload.NOT_FOUND_INFO' },
          {
            type,
            totalNumber,
            numberNotFound,
            customerCenter,
          },
        )}
      </div>
      <SerialNumbers>
        <p>{intl.formatMessage({ id: 'fileUpload.NOT_FOUND_SERIAL_COPY' })}</p>
        <StyledTextArea rows={4} disabled={true} value={notFoundNumbers.join('\n')} />
        <CopyToClipboard text={notFoundNumbers.join('\n')}>
          <UploadButton
            disabled={isLoading}
            marginTop={10}
          >
            {intl.formatMessage({ id: 'fileUpload.COPY_TO_CLIPBOARD' })}
          </UploadButton>
        </CopyToClipboard>
      </SerialNumbers>
      <Footer>
        {`${hasNext ?
          intl.formatMessage({ id: 'fileUpload.NEXT_PROBLEM' }) :
          intl.formatMessage({ id: 'fileUpload.NEXT_CREATE' }, { numberFound, type })
          } ${intl.formatMessage({ id: 'fileUpload.ALT' })}`}
      </Footer>
      <StyledInfoReference>{reference}</StyledInfoReference>
      <Buttons>
        <UploadButton
          onClick={() => notification.destroy('errorNotification')}
          disabled={isLoading}
        >
          {intl.formatMessage({ id: 'fileUpload.CANCEL_UPLOAD' })}
        </UploadButton>
        {hasNext ?
          <UploadButton
            primary={1}
            onClick={goToNextProblem}
          >
            {`${intl.formatMessage({ id: 'fileUpload.NEXT' })} >`}
          </UploadButton> :
          <UploadButton
            primary={1}
            onClick={
              () => {
                setIsLoading(true);
                createXMLRequest(
                  action,
                );
              }}
            disabled={isLoading}
            loading={isLoading}
          >
            {intl.formatMessage({ id: 'fileUpload.CONTINUE_UPLOAD' })}
          </UploadButton>
        }
      </Buttons>
    </>
  );
};
NotFoundError.propTypes = {
  title: PropTypes.string,
  numberNotFound: PropTypes.number,
  totalNumber: PropTypes.number,
  reference: PropTypes.string,
  intl: PropTypes.object,
  createXMLRequest: PropTypes.func,
  action: PropTypes.object,
  customerCenter: PropTypes.string,
  notFoundSerialNumbers: PropTypes.array,
  notFoundFunctionalLocationNumbers: PropTypes.array,
  numberFound: PropTypes.number,
  hasNext: PropTypes.bool,
  goToNextProblem: PropTypes.func,
};

export default NotFoundError;
